// Reads a design token (CSS custom property) at runtime, for JS animations
// that can't tween var() strings. See docs/adr/0001-design-system.md.
export const token = (name, el = document.documentElement) =>
  getComputedStyle(el).getPropertyValue(name).trim();

// Pixel tokens (e.g. --radius) as numbers for GSAP
export const tokenPx = (name, el) => parseFloat(token(name, el)) || 0;
